<template>
  <div class="checklist-empty-state" data-locator="empty-state">
    <div class="d-flex flex-column align-center justify-center row-gap-2">
      <h2 class="text--large text--bold">{{ $t(displayedTitle) }}</h2>
      <i18n-t :keypath="displayedText" tag="p" scope="global">
        <template #highlight>
          <span class="text--bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.textHighlight`) }}</span>
        </template>
      </i18n-t>
    </div>
    <img :src="localizedImageUrl" alt="" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import checklistEmptyStateDe from '@/assets/img/checklist/checklist_empty_state_de.png';
import checklistEmptyStateEn from '@/assets/img/checklist/checklist_empty_state_en.png';
import checklistEmptyStateFr from '@/assets/img/checklist/checklist_empty_state_fr.png';

const TRANSLATION_KEY_PREFIX = 'project.checklist.ChecklistEmptyState'

export default {
  name: 'ChecklistEmptyState',
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
    localizedImageUrl() {
      const imageMap = {
        fr: checklistEmptyStateFr,
        de: checklistEmptyStateDe,
      }

      return imageMap[this.$i18n.locale] || checklistEmptyStateEn
    },
    displayedText() {
      return `${TRANSLATION_KEY_PREFIX}.${this.isCurrentUserPm ? 'text' : 'textGuests'}`
    },
    displayedTitle() {
      return `${TRANSLATION_KEY_PREFIX}.${this.isCurrentUserPm ? 'title' : 'titleGuests'}`
    },
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.checklist-empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 24px;
  width: 100%;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    text-align: center;
  }

  img {
    width: 75%;
    max-width: 1200px;
    max-height: 100%;
    object-fit: contain;
    object-position: center;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      display: none;
    }
  }
}
</style>
